import { render, staticRenderFns } from "./AbroadHuiyiList.vue?vue&type=template&id=40408dee&scoped=true"
import script from "./AbroadHuiyiList.vue?vue&type=script&lang=js"
export * from "./AbroadHuiyiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40408dee",
  null
  
)

export default component.exports